import { allChatQuery } from './graphql'
import { useList, type UseListProps, type UseListResult } from '@ztechapps/common.hook'
import type { Chat } from '@ztechapps/common.contract'

export const useChatMessageList = ({ query, ...rest } = {} as UseListProps): UseListResult<Chat> => {
  query ??= allChatQuery
  return useList({
    query,
    limit: 30,
    filter: {
      status: { $ne: 'deleted' },
    },
    // Newest activity first
    sort: { lastMessageAt: -1 },
    ...rest,
  })
}
